import { render, staticRenderFns } from "./OwnerPatientDetail.vue?vue&type=template&id=e13314ec&scoped=true&"
import script from "./OwnerPatientDetail.vue?vue&type=script&lang=js&"
export * from "./OwnerPatientDetail.vue?vue&type=script&lang=js&"
import style0 from "./OwnerPatientDetail.vue?vue&type=style&index=0&id=e13314ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13314ec",
  null
  
)

export default component.exports